// @ts-nocheck
/**
 * New Nexode Pro - 留邮表单 + 规则弹窗 + GSAP 文案渐变
 */
(function () {
  'use strict';

  const TAG_NAME = 'new-nexode-pro-section';
  const FORM_SUBMIT_URL = 'https://ecf.cirkleinc.com/api/form-submit';

  function validateEmailFormat(email) {
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      String(email).toLowerCase()
    );
  }

  function bindEmailBlock(block) {
    if (!(block instanceof HTMLElement)) return;
    if (block.dataset.nnpEmailInited === '1') return;
    block.dataset.nnpEmailInited = '1';

    const submitBtn = block.querySelector('.ug-new-nexode-pro__email-submit');
    const input = block.querySelector('.ug-new-nexode-pro__email-input');
    const privacyCheckbox = block.querySelector('.ug-new-nexode-pro__email-checkbox');
    const errorMsg = block.querySelector('.ug-new-nexode-pro__email-error');
    const successMsg = block.querySelector('.ug-new-nexode-pro__email-message');

    const formId = block.getAttribute('data-form-id') || '';
    const successText = block.getAttribute('data-success-text') || 'Thanks for subscribing!';
    const failText = block.getAttribute('data-fail-text') || 'Subscription failed, please try again later.';
    const privacyError = block.getAttribute('data-privacy-error') || 'Please agree to the privacy policy.';
    const emailError = block.getAttribute('data-email-error') || 'Please enter a valid email address.';

    if (!(submitBtn instanceof HTMLButtonElement) || !(input instanceof HTMLInputElement)) {
      return;
    }

    const showError = (msg) => {
      if (errorMsg instanceof HTMLElement) {
        errorMsg.textContent = msg;
        errorMsg.style.display = 'block';
      }
      if (successMsg instanceof HTMLElement) {
        successMsg.style.display = 'none';
      }
    };

    const showSuccess = (msg) => {
      if (successMsg instanceof HTMLElement) {
        successMsg.textContent = msg;
        successMsg.style.display = 'block';
      }
      if (errorMsg instanceof HTMLElement) {
        errorMsg.style.display = 'none';
      }
    };

    const trackSubscription = (isSuccess) => {
      const w = window;
      if (!w.ugGa4Track || typeof w.ugGa4Track.subscriptionEvent !== 'function') return;
      try {
        w.ugGa4Track.subscriptionEvent({ isSuccess, position: 'new-nexode-pro' });
      } catch (_) {}
    };

    submitBtn.addEventListener('click', async () => {
      const emailVal = input.value.trim();

      if (!validateEmailFormat(emailVal)) {
        showError(emailError);
        return;
      }

      if (privacyCheckbox instanceof HTMLInputElement && !privacyCheckbox.checked) {
        showError(privacyError);
        return;
      }

      if (errorMsg instanceof HTMLElement) errorMsg.style.display = 'none';
      if (successMsg instanceof HTMLElement) successMsg.style.display = 'none';
      if (submitBtn.classList.contains('loading')) return;

      submitBtn.classList.add('loading');

      try {
        const response = await fetch(FORM_SUBMIT_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: emailVal,
            accepts_marketing:
              privacyCheckbox instanceof HTMLInputElement && privacyCheckbox.checked ? 'on' : 'off',
            form_id: formId
          })
        });

        let data = null;
        try {
          data = await response.json();
        } catch (_) {
          showError(failText);
          trackSubscription(false);
          return;
        }

        const isSuccess = data && data.status === 'success';
        if (isSuccess) {
          input.value = '';
          showSuccess(successText);
        } else {
          const serverMsg =
            (data && data.errors && data.errors.email && data.errors.email[0]) ||
            (data && data.message) ||
            failText;
          showError(serverMsg);
        }
        trackSubscription(!!isSuccess);
      } catch (_) {
        showError(failText);
        trackSubscription(false);
      } finally {
        submitBtn.classList.remove('loading');
      }
    });

    input.addEventListener('keydown', (e) => {
      if (e instanceof KeyboardEvent && e.key === 'Enter') {
        e.preventDefault();
        submitBtn.click();
      }
    });
  }

  /** 规则弹窗：打开 / 关闭 / Esc / 焦点恢复 */
  function bindTermsModal(termsSection) {
    if (!(termsSection instanceof HTMLElement)) return;
    if (termsSection.dataset.nnpTermsInited === '1') return;
    termsSection.dataset.nnpTermsInited = '1';

    const openBtn = termsSection.querySelector('[data-nnp-terms-open]');
    const modal = termsSection.querySelector('[data-nnp-terms-modal]');
    if (!(openBtn instanceof HTMLButtonElement) || !(modal instanceof HTMLElement)) return;

    const closeEls = modal.querySelectorAll('[data-nnp-terms-close]');
    const focusableSelector =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

    let lastFocus = null;

    const getFocusable = () =>
      Array.from(modal.querySelectorAll(focusableSelector)).filter(
        (el) =>
          el instanceof HTMLElement &&
          !el.hasAttribute('disabled') &&
          el.getAttribute('aria-hidden') !== 'true'
      );

    const open = () => {
      lastFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      modal.hidden = false;
      document.documentElement.classList.add('ug-nnp-terms-open');
      openBtn.setAttribute('aria-expanded', 'true');
      const first = getFocusable()[0];
      if (first instanceof HTMLElement) {
        window.requestAnimationFrame(() => first.focus());
      }
    };

    const close = () => {
      modal.hidden = true;
      document.documentElement.classList.remove('ug-nnp-terms-open');
      openBtn.setAttribute('aria-expanded', 'false');
      if (lastFocus && document.contains(lastFocus) && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      } else {
        openBtn.focus();
      }
      lastFocus = null;
    };

    const onDocKeydown = (e) => {
      if (e instanceof KeyboardEvent && e.key === 'Escape' && !modal.hidden) {
        e.preventDefault();
        close();
      }
    };

    openBtn.addEventListener('click', open);
    closeEls.forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', onDocKeydown, true);

    termsSection._nnpTermsCleanup = () => {
      openBtn.removeEventListener('click', open);
      closeEls.forEach((el) => el.removeEventListener('click', close));
      document.removeEventListener('keydown', onDocKeydown, true);
      if (!modal.hidden) {
        modal.hidden = true;
        document.documentElement.classList.remove('ug-nnp-terms-open');
        openBtn.setAttribute('aria-expanded', 'false');
      }
    };
  }

  /** 等待 GSAP / ScrollTrigger 就绪后再初始化滚动动画 */
  function whenGsapReady(onReady, onFail) {
    const attempt = () => {
      const gsap = window.gsap;
      const ScrollTrigger = window.ScrollTrigger;
      if (gsap && ScrollTrigger) {
        gsap.registerPlugin(ScrollTrigger);
        onReady(gsap, ScrollTrigger);
        return true;
      }
      return false;
    };

    if (attempt()) return;

    let tries = 0;
    const timer = window.setInterval(() => {
      tries += 1;
      if (attempt()) {
        window.clearInterval(timer);
      } else if (tries >= 80) {
        window.clearInterval(timer);
        if (typeof onFail === 'function') onFail();
      }
    }, 50);
  }

  /** 文案过渡：line-final 滚动淡入；卖点接文案 end 后入场 */

  function getScrollPos(section, ScrollTrigger, position) {
    const probe = ScrollTrigger.create({ trigger: section, start: position, end: position });
    const y = probe.start;
    probe.kill();
    return y;
  }

  /** 核心卖点：区块进入视口后滚动驱动入场（接在文案过渡之后） */
  function getProductIntroY(product) {
    if (!(product instanceof HTMLElement)) return 0;
    const section = product.closest('[data-nnp-highlights]');
    const stageH = section instanceof HTMLElement ? section.offsetHeight : 0;
    const isMobile = window.matchMedia('(max-width: 1023.98px)').matches;
    // 2x 放大时向下偏移，避免顶部裁切（MO 额外下移约 100px）
    if (isMobile) {
      return stageH * 0.14 + 100;
    }
    return stageH * 0.22;
  }

  /** PC 描述卡从两侧滑入的初始 X */
  function getPcCardIntroX(card) {
    if (!(card instanceof HTMLElement)) return 0;
    if (card.classList.contains('ug-new-nexode-pro__highlights-card--1')) return -100;
    return 100;
  }

  /** 初始化引线描边动画起点 */
  function setLinePathsForAnimation(gsap, paths) {
    paths.forEach((path) => {
      const len = path.getTotalLength();
      gsap.set(path, { strokeDasharray: len, strokeDashoffset: len });
    });
  }

  function finalizeHighlights(section, gsap, refs) {
    const { product, bg, pcCards, linePaths, pcHotspots, moPanel, moHotspots, isMobile } = refs;
    section.classList.add('is-revealed');
    if (product) gsap.set(product, { y: 0, scale: 1, rotation: 0, xPercent: -50 });
    if (bg) gsap.set(bg, { opacity: 1 });
    if (pcCards.length) gsap.set(pcCards, { opacity: 1, x: 0 });
    if (linePaths.length) gsap.set(linePaths, { strokeDashoffset: 0 });
    if (isMobile && moHotspots.length) {
      gsap.set(moHotspots, { opacity: 1, clearProps: 'opacity' });
    } else if (pcHotspots.length) {
      pcHotspots.forEach((hotspot) => gsap.set(hotspot, { xPercent: -50, yPercent: -50, scale: 1 }));
    }
    if (moPanel) gsap.set(moPanel, { opacity: 1, y: 0, scale: 1, clearProps: 'opacity,transform' });
  }

  function setupHighlightsScroll(section, gsap, ScrollTrigger, textST) {
    const product = section.querySelector('[data-nnp-highlight-product]');
    const bg = section.querySelector('.ug-new-nexode-pro__highlights-bg');
    const lines = section.querySelector('.ug-new-nexode-pro__highlights-lines');
    const hotspotsPc = section.querySelector('.ug-new-nexode-pro__highlights-hotspots-pc');
    const hotspotsMo = section.querySelector('.ug-new-nexode-pro__highlights-hotspots-mo');
    const pcCards = section.querySelectorAll(
      '.ug-new-nexode-pro__highlights-pc-cards .ug-new-nexode-pro__highlights-card'
    );
    const moPanel = section.querySelector('.ug-new-nexode-pro__highlights-mo-panel');
    const isMobile = window.matchMedia('(max-width: 1023.98px)').matches;
    const linePaths = lines ? Array.from(lines.querySelectorAll('path')) : [];
    const pcHotspots = hotspotsPc
      ? Array.from(hotspotsPc.querySelectorAll('.ug-new-nexode-pro__highlights-hotspot'))
      : [];
    const moHotspots = hotspotsMo
      ? Array.from(hotspotsMo.querySelectorAll('.ug-new-nexode-pro__highlights-hotspot'))
      : [];

    section.classList.add('is-gsap-ready');

    const introY = getProductIntroY(product);

    if (product instanceof HTMLElement) {
      gsap.set(product, {
        xPercent: -50,
        y: introY,
        scale: 2,
        rotation: 5,
        transformOrigin: '50% 50%',
        force3D: true
      });
    }
    if (bg instanceof HTMLElement) gsap.set(bg, { opacity: 0.45 });
    setLinePathsForAnimation(gsap, linePaths);
    pcCards.forEach((card) => gsap.set(card, { opacity: 0, x: getPcCardIntroX(card) }));
    if (isMobile) {
      moHotspots.forEach((hotspot) => gsap.set(hotspot, { opacity: 0 }));
      if (moPanel instanceof HTMLElement) {
        gsap.set(moPanel, { opacity: 1, y: 0, scale: 1 });
      }
    } else {
      pcHotspots.forEach((hotspot) =>
        gsap.set(hotspot, { xPercent: -50, yPercent: -50, scale: 0, transformOrigin: '50% 50%' })
      );
    }

    const refs = { product, bg, pcCards, linePaths, pcHotspots, moPanel, moHotspots, isMobile };

    const setRevealed = (revealed) => {
      section.classList.toggle('is-revealed', revealed);
      if (revealed) finalizeHighlights(section, gsap, refs);
    };
    const getStart = () => {
      const enter = getScrollPos(section, ScrollTrigger, 'top bottom');
      const textEnd = textST && typeof textST.end === 'number' ? textST.end : enter;
      return Math.max(textEnd, enter);
    };
    const getEnd = () => getScrollPos(section, ScrollTrigger, 'center center');

    if (getStart() >= getEnd()) {
      finalizeHighlights(section, gsap, refs);
      section._nnpHighlightsScrollTrigger = null;
      section._nnpHighlightsScrollCleanup = () => {
        section.classList.remove('is-gsap-ready', 'is-revealed');
        delete section.dataset.nnpHighlightsScrollInited;
        delete section._nnpHighlightsScrollTrigger;
      };
      return;
    }

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: getStart,
        end: 'center center',
        scrub: 0.3,
        invalidateOnRefresh: true,
        fastScrollEnd: true,
        onUpdate: (self) => setRevealed(self.progress >= 0.999)
      },
      defaults: { ease: 'none' }
    });

    if (product instanceof HTMLElement) {
      tl.to(product, { y: 0, scale: 1, rotation: 0, duration: 0.5 }, 0);
    }
    if (bg instanceof HTMLElement) {
      tl.to(bg, { opacity: 1, duration: 0.18 }, 0.4);
    }
    if (!isMobile && pcCards.length) {
      tl.to(pcCards, { opacity: 1, x: 0, duration: 0.18, stagger: 0.05 }, 0.58);
    }
    if (!isMobile && linePaths.length) {
      tl.to(linePaths, { strokeDashoffset: 0, duration: 0.26, stagger: 0.06 }, 0.72);
    }
    if (!isMobile && pcHotspots.length) {
      tl.to(pcHotspots, { scale: 1, duration: 0.14, stagger: 0.05 }, 0.9);
    }
    if (isMobile && moHotspots.length) {
      tl.to(moHotspots, { opacity: 1, duration: 0.14, stagger: 0.05 }, 0.88);
    }

    const scrollTrigger = tl.scrollTrigger;
    section._nnpHighlightsScrollTrigger = scrollTrigger;

    const onResize = () => {
      if (product instanceof HTMLElement && scrollTrigger.progress < 0.01) {
        gsap.set(product, { y: getProductIntroY(product) });
      }
      scrollTrigger.refresh();
    };

    let resizeTimer = 0;
    const debouncedResize = () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(onResize, 150);
    };
    window.addEventListener('resize', debouncedResize);
    window.addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
    window.requestAnimationFrame(() => ScrollTrigger.refresh());

    section._nnpHighlightsScrollCleanup = () => {
      window.removeEventListener('resize', debouncedResize);
      window.clearTimeout(resizeTimer);
      if (scrollTrigger) scrollTrigger.kill();
      tl.kill();
      section.classList.remove('is-gsap-ready', 'is-revealed');
      if (product instanceof HTMLElement) gsap.set(product, { clearProps: 'transform' });
      if (bg instanceof HTMLElement) gsap.set(bg, { clearProps: 'opacity' });
      if (linePaths.length) gsap.set(linePaths, { clearProps: 'strokeDashoffset,strokeDasharray' });
      if (pcCards.length) gsap.set(pcCards, { clearProps: 'opacity,transform' });
      if (pcHotspots.length) gsap.set(pcHotspots, { clearProps: 'transform' });
      if (moHotspots.length) gsap.set(moHotspots, { clearProps: 'opacity' });
      if (moPanel instanceof HTMLElement) gsap.set(moPanel, { clearProps: 'opacity,transform' });
      delete section.dataset.nnpHighlightsScrollInited;
      delete section._nnpHighlightsScrollTrigger;
    };
  }

  function bindHighlightsScroll(section) {
    if (!(section instanceof HTMLElement)) return;
    if (section.dataset.nnpHighlightsScrollInited === '1') return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) {
      section.dataset.nnpHighlightsScrollInited = '1';
      section.classList.add('is-revealed');
      return;
    }

    whenGsapReady(
      (gsap, ScrollTrigger) => {
        const root = section.closest('new-nexode-pro-section');
        const textSection = root ? root.querySelector('[data-nnp-text-reveal]') : null;

        const run = () => {
          if (section.dataset.nnpHighlightsScrollInited === '1') return;
          section.dataset.nnpHighlightsScrollInited = '1';

          const textST = textSection && textSection._nnpTextGradientScrollTrigger;
          setupHighlightsScroll(section, gsap, ScrollTrigger, textST);
          ScrollTrigger.refresh();
        };

        const waitForText = () => {
          if (
            !textSection ||
            textSection._nnpTextGradientScrollTrigger ||
            textSection.dataset.nnpTextGradientInited === '1'
          ) {
            run();
            return;
          }
          window.requestAnimationFrame(waitForText);
        };

        waitForText();
      },
      () => {
        section.dataset.nnpHighlightsScrollInited = '1';
        section.classList.add('is-revealed');
      }
    );
  }

  /** MO 轮播：初始化第一张，热点 + 左右按钮切换 */
  function bindHighlightsCarousel(section) {
    if (!(section instanceof HTMLElement)) return;
    if (section.dataset.nnpHighlightsCarouselInited === '1') return;
    section.dataset.nnpHighlightsCarouselInited = '1';

    const slides = Array.from(section.querySelectorAll('[data-nnp-highlight-slide]'));
    const moHotspotsRoot = section.querySelector('.ug-new-nexode-pro__highlights-hotspots-mo');
    const hotspots = moHotspotsRoot
      ? Array.from(moHotspotsRoot.querySelectorAll('[data-nnp-highlight-go]'))
      : [];
    const prevBtn = section.querySelector('[data-nnp-highlight-prev]');
    const nextBtn = section.querySelector('[data-nnp-highlight-next]');
    const progress = section.querySelector('[data-nnp-highlight-progress]');
    const progressFill = section.querySelector('[data-nnp-highlight-progress-fill]');

    if (!slides.length) return;

    let index = 0;
    const cleanups = [];

    const canInteract = () => {
      if (section.classList.contains('is-revealed')) return true;
      return (
        window.matchMedia('(max-width: 1023.98px)').matches &&
        section.classList.contains('is-gsap-ready')
      );
    };

    const render = () => {
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.hidden = !active;
      });

      hotspots.forEach((hotspot) => {
        const raw = hotspot.getAttribute('data-nnp-highlight-go');
        const target = raw !== null ? Number(raw) : NaN;
        hotspot.classList.toggle('is-active', !Number.isNaN(target) && target === index);
      });

      if (progress instanceof HTMLElement) {
        progress.setAttribute('aria-valuenow', String(index + 1));
      }

      if (progressFill instanceof HTMLElement) {
        const pct = ((index + 1) / slides.length) * 100;
        progressFill.style.width = pct + '%';
      }
    };

    const goTo = (nextIndex) => {
      if (!canInteract()) return;
      const total = slides.length;
      index = ((nextIndex % total) + total) % total;
      render();
    };

    hotspots.forEach((hotspot) => {
      const handler = () => {
        const raw = hotspot.getAttribute('data-nnp-highlight-go');
        const target = raw !== null ? Number(raw) : NaN;
        if (!Number.isNaN(target)) goTo(target);
      };
      hotspot.addEventListener('click', handler);
      cleanups.push(() => hotspot.removeEventListener('click', handler));
    });

    if (prevBtn instanceof HTMLButtonElement) {
      const handler = () => goTo(index - 1);
      prevBtn.addEventListener('click', handler);
      cleanups.push(() => prevBtn.removeEventListener('click', handler));
    }

    if (nextBtn instanceof HTMLButtonElement) {
      const handler = () => goTo(index + 1);
      nextBtn.addEventListener('click', handler);
      cleanups.push(() => nextBtn.removeEventListener('click', handler));
    }

    render();

    section._nnpHighlightsCarouselCleanup = () => {
      cleanups.forEach((fn) => {
        try {
          fn();
        } catch (_) {}
      });
      delete section._nnpHighlightsCarouselCleanup;
      delete section.dataset.nnpHighlightsCarouselInited;
    };
  }

  function bindHighlights(section) {
    bindHighlightsScroll(section);
    bindHighlightsCarousel(section);
  }

  function bindTextGradientScroll(section) {
    if (!(section instanceof HTMLElement)) return;
    if (section.dataset.nnpTextGradientInited === '1') return;

    const initEl = section.querySelector('.ug-new-nexode-pro__text-transition-line-init');
    const finalEl = section.querySelector('.ug-new-nexode-pro__text-transition-line-final');
    if (!(initEl instanceof HTMLElement) || !(finalEl instanceof HTMLElement)) {
      // 标题为空时 DOM 无渐变节点，仍需标记已初始化，避免卖点区 waitForText 死循环
      section.dataset.nnpTextGradientInited = '1';
      section.classList.add('is-revealed');
      return;
    }

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) {
      section.dataset.nnpTextGradientInited = '1';
      section.classList.add('is-revealed');
      return;
    }

    whenGsapReady(
      (gsap, ScrollTrigger) => {
        if (section.dataset.nnpTextGradientInited === '1') return;
        section.dataset.nnpTextGradientInited = '1';

        gsap.set(finalEl, { opacity: 0 });

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: section,
            start: 'bottom bottom',
            end: 'center center',
            scrub: 0.3,
            invalidateOnRefresh: true,
            fastScrollEnd: true
          },
          defaults: { ease: 'none' }
        });

        tl.to(finalEl, { opacity: 1, duration: 1 });

        const scrollTrigger = tl.scrollTrigger;
        section._nnpTextGradientScrollTrigger = scrollTrigger;

        window.addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
        window.requestAnimationFrame(() => ScrollTrigger.refresh());

        section._nnpTextGradientCleanup = () => {
          scrollTrigger.kill();
          tl.kill();
          gsap.set(finalEl, { clearProps: 'opacity' });
          delete section._nnpTextGradientScrollTrigger;
          delete section.dataset.nnpTextGradientInited;
        };
      },
      () => {
        section.dataset.nnpTextGradientInited = '1';
        section.classList.add('is-revealed');
      }
    );
  }

  function initSection(root) {
    root.querySelectorAll('[data-nnp-email]').forEach(bindEmailBlock);
    root.querySelectorAll('.ug-new-nexode-pro__terms').forEach(bindTermsModal);
    // 文案过渡必须先于卖点初始化，以便串联 ScrollTrigger
    root.querySelectorAll('[data-nnp-text-reveal]').forEach(bindTextGradientScroll);
    root.querySelectorAll('[data-nnp-highlights]').forEach(bindHighlights);
  }

  if (customElements.get(TAG_NAME)) {
    return;
  }

  class NewNexodeProSection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.nnpInited === '1') return;
      this.dataset.nnpInited = '1';
      initSection(this);
    }

    disconnectedCallback() {
      delete this.dataset.nnpInited;
      this.querySelectorAll('.ug-new-nexode-pro__terms').forEach((section) => {
        if (section._nnpTermsCleanup) {
          try {
            section._nnpTermsCleanup();
          } catch (_) {}
          delete section._nnpTermsCleanup;
        }
      });
      this.querySelectorAll('[data-nnp-text-reveal]').forEach((section) => {
        if (section._nnpTextGradientCleanup) {
          try {
            section._nnpTextGradientCleanup();
          } catch (_) {}
          delete section._nnpTextGradientCleanup;
        }
      });
      this.querySelectorAll('[data-nnp-highlights]').forEach((section) => {
        if (section._nnpHighlightsScrollCleanup) {
          try {
            section._nnpHighlightsScrollCleanup();
          } catch (_) {}
          delete section._nnpHighlightsScrollCleanup;
        }
        if (section._nnpHighlightsCarouselCleanup) {
          try {
            section._nnpHighlightsCarouselCleanup();
          } catch (_) {}
        }
      });
    }
  }

  customElements.define(TAG_NAME, NewNexodeProSection);
})();
